var p = Object.freeze, E = Object.defineProperty;
var a = (o, t) => p(E(o, "raw", { value: p(t || o.slice()) }));
import { i as g, x as f } from "./lit-element-CwWchyls.js";
import { n as d } from "./property-EvzlnPW3.js";
import { r as h } from "./state-D88UmDIj.js";
import { e as O } from "./class-map-CiBNip0q.js";
import { L as S } from "./lds-element-BuoW29Nx.js";
import { s as N, a as I } from "./context-D-64zexR.js";
import { generateUUID as C } from "./utils/uuid.js";
import { L } from "./multi-select.component-DnJdCgpp.js";
import "./lds-checkbox.js";
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
class m {
  constructor(t, e, s, i) {
    var n;
    if (this.subscribe = !1, this.provided = !1, this.value = void 0, this.t = (c, u) => {
      this.unsubscribe && (this.unsubscribe !== u && (this.provided = !1, this.unsubscribe()), this.subscribe || this.unsubscribe()), this.value = c, this.host.requestUpdate(), this.provided && !this.subscribe || (this.provided = !0, this.callback && this.callback(c, u)), this.unsubscribe = u;
    }, this.host = t, e.context !== void 0) {
      const c = e;
      this.context = c.context, this.callback = c.callback, this.subscribe = (n = c.subscribe) != null ? n : !1;
    } else this.context = e, this.callback = s, this.subscribe = i != null ? i : !1;
    this.host.addController(this);
  }
  hostConnected() {
    this.dispatchRequest();
  }
  hostDisconnected() {
    this.unsubscribe && (this.unsubscribe(), this.unsubscribe = void 0);
  }
  dispatchRequest() {
    this.host.dispatchEvent(new N(this.context, this.t, this.subscribe));
  }
}
/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function M({ context: o, subscribe: t }) {
  return (e, s) => {
    typeof s == "object" ? s.addInitializer(function() {
      new m(this, { context: o, callback: (i) => {
        e.set.call(this, i);
      }, subscribe: t });
    }) : e.constructor.addInitializer((i) => {
      new m(i, { context: o, callback: (n) => {
        i[s] = n;
      }, subscribe: t });
    });
  };
}
var v;
const R = g(v || (v = a(["\n    .base {\n        cursor: pointer;\n        padding: var(--lds-spacing-sm) var(--lds-spacing-md);\n        background-color: var(--lds-color-default-0);\n        user-select: none;\n    }\n\n    .base:hover {\n        background-color: var(--lds-color-default-20);\n    }\n\n    .base.selected {\n        background-color: var(--lds-color-primary);\n        color: var(--lds-text-invert);\n    }\n\n    .multi-select .base.selected {\n        background-color: transparent;\n    }\n"])));
var T = Object.defineProperty, l = (o, t, e, s) => {
  for (var i = void 0, n = o.length - 1, c; n >= 0; n--)
    (c = o[n]) && (i = c(t, e, i) || i);
  return i && T(t, e, i), i;
}, x, y;
const b = class b extends S {
  constructor() {
    super(), this.role = "option", this.value = "", this.selected = !1, this.uuid = C(), this.isMultiSelectOption = !1, this.tabIndex = 0, this.addEventListener("click", this.onClick), this.addEventListener("keyup", (t) => {
      t.key === "Enter" && this.click();
    });
  }
  onClick() {
    var t, e;
    (e = (t = this.context) == null ? void 0 : t.setActive) == null || e.call(t, this);
  }
  firstUpdated() {
    this.parentElement instanceof L && (this.isMultiSelectOption = !0);
  }
  // https://github.com/shoelace-style/shoelace/blob/next/src/components/option/option.component.ts#L109
  /** Returns a plain text label based on the option's content. */
  getTextLabel() {
    const t = this.childNodes;
    let e = "";
    return [...t].forEach((s) => {
      s.nodeType === Node.ELEMENT_NODE && (s.hasAttribute("slot") || (e += s.textContent)), s.nodeType === Node.TEXT_NODE && (e += s.textContent);
    }), e.trim();
  }
  render() {
    var t, e, s;
    return f(y || (y = a([' <div\n            part="base"\n            class="base', '">\n            ', "\n            <slot></slot>\n        </div>"])), O({
      selected: !this.isMultiSelectOption && ((t = this.context) == null ? void 0 : t.activeOption) === this.uuid
    }), this.isMultiSelectOption ? f(x || (x = a(["<lds-checkbox\n                      readonly\n                      ?checked=", "></lds-checkbox>"])), !!((s = (e = this.context) == null ? void 0 : e.activeOptions) != null && s.includes(this.uuid))) : "");
  }
};
b.styles = R;
let r = b;
l([
  d({ type: String, reflect: !0 })
], r.prototype, "role");
l([
  d({ type: String, reflect: !0 })
], r.prototype, "value");
l([
  d({ type: Boolean, reflect: !0 })
], r.prototype, "selected");
l([
  M({ context: I, subscribe: !0 }),
  h()
], r.prototype, "context");
l([
  h()
], r.prototype, "uuid");
l([
  h()
], r.prototype, "isMultiSelectOption");
l([
  d({ type: Number, reflect: !0 })
], r.prototype, "tabIndex");
const k = new URL(import.meta.url), $ = k.searchParams.has("debug");
if (!k.searchParams.has("no-define")) {
  const o = customElements.get("lds-option");
  o ? o.VERSION !== r.VERSION && $ && console.log("%clds-option tried loading in version ".concat(r.VERSION, ", but lds-option is already defined as ").concat(o.VERSION), "font-weight: bold; font-size: 16px; color: red;") : customElements.define("lds-option", r);
}
export {
  r as LdsOption
};
